import React, { useState, useEffect } from 'react';
import QrScanner from 'qr-scanner';


const BACKEND_URL = 'https://web3-pos-v2.gdbok.workers.dev';

// ✅ ADD THIS - Translations object
const TRANSLATIONS = {
  1: { // Spanish
    title: 'Setup POS',
    subtitle: 'Escanea el código QR o ingresalo manualmente',
    scanQR: '📷 Scan QR',
    enterCode: '⌨️ Manual',
    tokenCode: 'Código del Token',
    enterCodePlaceholder: '8 caracteres',
    initializePOS: 'Inicializar POS',
    initializing: 'Inicializando...',
    positionQR: 'Posiciona el código QR dentro del marco',
    cameraError: 'Acceso a cámara denegado. Por favor usa la entrada manual.',
    invalidCode: 'Por favor ingresa un código de 8 caracteres',
    networkError: 'Error de red. Por favor intenta de nuevo.'
  },
  2: { // English
    title: 'Setup POS',
    subtitle: 'Scan token QR code or enter code manually',
    scanQR: '📷 Scan QR',
    enterCode: '⌨️ Manual',
    tokenCode: 'Token Code',
    enterCodePlaceholder: '8 character',
    initializePOS: 'Initialize POS',
    initializing: 'Initializing...',
    positionQR: 'Position the QR code within the frame',
    cameraError: 'Camera access denied. Please use manual code entry.',
    invalidCode: 'Please enter an 8-character code',
    networkError: 'Network error. Please try again.'
  }
};





export const POSInitialization = ({ onInitialized, lang = 1, onLangChange }) => {
  const [mode, setMode] = useState('scan'); // 'scan' or 'manual'
  const t = TRANSLATIONS[lang];
  const [humanCode, setHumanCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [cameraError, setCameraError] = useState(false);
  const videoRef = React.useRef(null);
  const scannerRef = React.useRef(null);

  useEffect(() => {
    if (mode === 'scan' && videoRef.current) {
      startScanner();
    }

    return () => {
      if (scannerRef.current) {
        scannerRef.current.stop();
        scannerRef.current.destroy();
      }
    };
  }, [mode]);





  const startScanner = async () => {
    try {
      if (scannerRef.current) {
        scannerRef.current.stop();
        scannerRef.current.destroy();
      }

      const scanner = new QrScanner(
        videoRef.current,
        result => handleScan(result.data),
        {
          returnDetailedScanResult: true,
          highlightScanRegion: true,
          highlightCodeOutline: true
        }
      );

      await scanner.start();
      scannerRef.current = scanner;
      setCameraError(false);
    } catch (err) {
      console.error('Camera error:', err);
      setCameraError(true);
      setMode('manual');
    }
  };

  const handleScan = async (data) => {
    if (loading) return;

    try {
      const parsed = JSON.parse(data);
      
      if (parsed.type === 'POS_INIT' && (parsed.tokenId || parsed.humanCode)) {
        setLoading(true);
        await initializePOS(parsed.tokenId, parsed.humanCode);
      }
    } catch (err) {
      console.error('Invalid QR code:', err);
    }
  };

  const handleManualSubmit = async (e) => {
    e.preventDefault();
    setError('');

if (!humanCode || humanCode.length !== 8) {
  setError(t.invalidCode);
  return;
}

    setLoading(true);
    
    await initializePOS(null, humanCode);
  };

  const initializePOS = async (tokenId, humanCode) => {
    try {
      // Generate or get POS ID
      let posId = localStorage.getItem('pos_device_id');
      if (!posId) {
        posId = 'POS_' + Math.random().toString(36).substring(2, 15);
        localStorage.setItem('pos_device_id', posId);
      }

      const response = await fetch(`${BACKEND_URL}/api/pos/initialize`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tokenId: tokenId || undefined,
          humanCode: humanCode || undefined,
          posId
        })
      });

      const result = await response.json();

      if (!response.ok) {
        setError(result.error || 'Initialization failed');
        setLoading(false);
        return;
      }

     if (result.success) {
  // Store POS settings in localStorage (simplified schema)
  const posSettings = {
    tokenId: result.settings.tokenId,
    tokenName: result.settings.tokenName,
    genericToken: result.settings.genericToken,
    fiatCurrency: result.settings.fiatCurrency,  // ✅ NEW
    merchantWallet: result.settings.merchantWallet,
    posId,
    initializedAt: Date.now()
  };

  localStorage.setItem('pos_settings', JSON.stringify(posSettings));
  localStorage.setItem('pos_initialized', 'true');

  console.log('✅ POS initialized:', posSettings);

  onInitialized(posSettings);
}
    } catch (err) {
      console.error('Initialize POS error:', err);
      setError(t.networkError);
      setLoading(false);
    }
  };

return (
  <div style={{
    maxWidth: '420px',
    width: '100%',
    margin: '0 auto',
    padding: '40px 20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    boxSizing: 'border-box'
  }}>
    
{/* ✅ NEW: Header with title and language toggle */}
<div style={{ 
  textAlign: 'center', 
  marginBottom: '32px',
  position: 'relative'
}}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        marginBottom: '8px'
      }}>
        <h1 style={{ 
          fontSize: '24px', 
          fontWeight: '700',
          margin: 0
        }}>
          📱 {t.title}
        </h1>
      </div>

      

      <p style={{ color: '#6b7280', fontSize: '14px', margin: 0 }}>
                        
        {t.subtitle}
      </p>
    </div>

    {/* Mode selector tabs */}
    <div style={{
      display: 'flex',
      gap: '8px',
      marginBottom: '24px',
      background: '#f9fafb',
      padding: '4px',
      borderRadius: '8px'
    }}>
      <button
        onClick={() => setMode('scan')}
        style={{
          flex: 1,
          padding: '10px',
          fontSize: '14px',
          fontWeight: '600',
          background: mode === 'scan' ? 'white' : 'transparent',
          color: mode === 'scan' ? '#6366f1' : '#6b7280',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          boxShadow: mode === 'scan' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none'
        }}
      >
        {t.scanQR}
      </button>
      <button
        onClick={() => setMode('manual')}
        style={{
          flex: 1,
          padding: '10px',
          fontSize: '14px',
          fontWeight: '600',
          background: mode === 'manual' ? 'white' : 'transparent',
          color: mode === 'manual' ? '#6366f1' : '#6b7280',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          boxShadow: mode === 'manual' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none'
        }}
      >
        {t.enterCode}
      </button>
    </div>

    {/* Scan mode */}
    {mode === 'scan' && (
      <div>
        {!cameraError ? (
         <div style={{
            position: 'relative',
            width: '100%',
            maxWidth: '380px',
            margin: '0 auto',
            paddingBottom: '100%',
            background: '#000',
            borderRadius: '12px',
            overflow: 'hidden'
          }}>
            <video
              ref={videoRef}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
            {loading && (
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(0,0,0,0.7)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: '16px',
                fontWeight: '600'
              }}>
                {t.initializing}
              </div>
            )}
          </div>
        ) : (
          <div style={{
            padding: '40px',
            textAlign: 'center',
            background: '#fee2e2',
            borderRadius: '12px',
            border: '1px solid #fecaca'
          }}>
            <div style={{ fontSize: '32px', marginBottom: '12px' }}>📷</div>
            <p style={{ color: '#991b1b', fontSize: '14px', margin: 0 }}>
              {t.cameraError}
            </p>
          </div>
        )}

        <p style={{
          textAlign: 'center',
          color: '#6b7280',
          fontSize: '13px',
          marginTop: '16px'
        }}>
          {t.positionQR}
        </p>
      </div>
    )}

    {/* Manual mode */}
    {mode === 'manual' && (
      <form onSubmit={handleManualSubmit}>
        <div style={{ marginBottom: '16px' }}>
          <label style={{
            display: 'block',
            fontSize: '13px',
            fontWeight: '600',
            marginBottom: '6px',
            color: '#374151'
          }}>
            {t.tokenCode}
          </label>
          <input
            type="text"
            placeholder={t.enterCodePlaceholder}
            value={humanCode}
            onChange={(e) => setHumanCode(e.target.value.toUpperCase().slice(0, 8))}
            maxLength={8}
            style={{
              width: '100%',
              padding: '12px',
              fontSize: '18px',
              fontWeight: '600',
              fontFamily: 'monospace',
              letterSpacing: '4px',
              textAlign: 'center',
              border: '2px solid #d1d5db',
              borderRadius: '8px',
              boxSizing: 'border-box',
              textTransform: 'uppercase'
            }}
            autoFocus
          />
        </div>

        <button
          type="submit"
          disabled={loading || humanCode.length !== 8}
          style={{
            width: '100%',
            padding: '12px',
            fontSize: '15px',
            fontWeight: '600',
            background: (loading || humanCode.length !== 8) ? '#9ca3af' : 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: (loading || humanCode.length !== 8) ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? t.initializing : t.initializePOS}
        </button>
      </form>
    )}

    {/* Error message */}
    {error && (
      <div style={{
        marginTop: '16px',
        background: '#fee2e2',
        color: '#991b1b',
        padding: '12px',
        borderRadius: '8px',
        fontSize: '13px',
        border: '1px solid #fecaca'
      }}>
        ⚠️ {error}
      </div>
    )}
  </div>
);

};

export default POSInitialization;